import React from 'react';
import { CreditCardIcon, FileTextIcon, LayersIcon, LockIcon, ShieldCheckIcon, SparklesIcon, ZapIcon } from 'lucide-react';
import { heroStats, mockupUrl } from '../data/content';
import { Button } from './ui/Button';
const badges = [[FileTextIcon, '100% PDF'], [ZapIcon, 'Acceso en 5 min'], [LayersIcon, 'Todos los biotipos'], [SparklesIcon, 'Principiante → Avanzado']] as const;
export function Hero() {
  return <section className="relative overflow-hidden px-4 pb-14 pt-9 md:pb-20 md:pt-14" data-id="element-176" data-mp="128pixfs3x15m">
      <div className="pointer-events-none absolute left-1/2 top-[22%] h-[560px] w-[560px] -translate-x-1/2 rounded-full bg-primary/10 blur-[120px]" data-id="element-177" data-mp="xbpbb0flzqce" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-178" data-mp="nc858hwg3afw">
        <div className="mb-5 inline-flex rounded-full border border-primary/20 bg-primary/10 px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-wider text-primary md:mb-6" data-id="element-179" data-mp="nbyh6zuyndcu">
          CompraDigitalYa™
        </div>
        <h1 className="mx-auto max-w-4xl text-[1.75rem] font-black uppercase leading-[1.05] tracking-tight text-ink md:text-[3.6rem]" data-id="element-180" data-mp="384s4img5wh20">
          🧴 Facial PRO 2026
        </h1>

        <a href="#pricing" className="group my-6 flex justify-center rounded-3xl focus:outline-none md:my-8" aria-label="Ver el precio del Facial PRO 2026" data-id="element-181" data-mp="3o6u6n92nspce">
          <img className="w-full max-w-[680px] object-contain drop-shadow-[0_26px_44px_rgba(27,94,63,.26)] transition-transform duration-300 ease-out group-hover:scale-[1.015]" src={mockupUrl} alt="Mockup del sistema Facial PRO 2026 con sus 5 módulos y 3 bonos" data-id="element-182" data-mp="3e7l61xdagch2" />
        </a>

        <p className="mx-auto max-w-4xl text-xl font-black leading-tight text-primary md:text-4xl" data-id="element-183" data-mp="2qi0mbc9b9b6q">
          Todo tu año de protocolos de limpieza facial. Listo. Desde hoy.
        </p>

        <p className="mx-auto mt-5 max-w-3xl text-base font-semibold leading-relaxed text-slate-600 md:text-xl" data-id="element-184" data-mp="2hl9sl6i8e8fb">
          <strong className="text-ink" data-id="element-185" data-mp="2lmlcqwic61g4">
            🧴 EL SISTEMA COMPLETO PARA PROFESIONALES DE ESTÉTICA FACIAL EN ARGENTINA.
          </strong>{' '}
          Principiante → Avanzado, todos los niveles. Protocolos + evaluaciones + extracciones +
          situaciones difíciles listos para usar. Sin cicatrices. Sin improviso.
        </p>

        <div className="mt-6 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs font-semibold text-slate-600 md:text-sm" data-id="element-186" data-mp="de6o0r03e1ks">
          {badges.map(([BadgeIcon, label]) => <span key={label} className="flex items-center gap-1.5" data-id="element-187" data-mp="1622jxthu7pgi">
              <BadgeIcon className="h-4 w-4 text-primary" data-id="element-188" data-mp="15zq5vrf79z8q" />
              {label}
            </span>)}
        </div>

        <div className="mt-7" data-id="element-189" data-mp="x1edpkyoqte6">
          <Button href="#pricing" className="w-full text-sm md:w-auto md:px-10 md:py-5 md:text-lg" data-id="element-190" data-mp="x032x16toldk">
            🧴 QUIERO MI FACIAL PRO AHORA →
          </Button>
        </div>

        <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] font-semibold text-slate-500 md:text-sm" data-id="element-191" data-mp="3hqu105yp3zz2">
          <span className="flex items-center gap-1" data-id="element-192" data-mp="1xam4cnf59kxc">
            <ShieldCheckIcon className="h-3.5 w-3.5 text-primary" data-id="element-193" data-mp="21amw19r97smc" />
            Garantía 7 días
          </span>
          <span className="text-primary/30" data-id="element-194" data-mp="269hc43xu732r">·</span>
          <span className="flex items-center gap-1" data-id="element-195" data-mp="268obzltdvbtl">
            <LockIcon className="h-3.5 w-3.5 text-primary" data-id="element-196" data-mp="2b0ze8vblj9pb" />
            Pago seguro
          </span>
          <span className="text-primary/30" data-id="element-197" data-mp="2g0lpx0bs0hw0">·</span>
          <span className="flex items-center gap-1" data-id="element-198" data-mp="2g1wyddg62dtg">
            <CreditCardIcon className="h-3.5 w-3.5 text-primary" data-id="element-199" data-mp="2kxucdd3yj832" />
            Mercado Pago
          </span>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-3 md:mt-14 md:grid-cols-4" data-id="element-200" data-mp="2p10ec8k1ed3q">
          {heroStats.map(([value, label]) => <div key={label} className="rounded-2xl border border-line bg-white p-4 text-center shadow-sm" data-id="element-201" data-mp="2tx7mm7zwo0ou">
              <p className="text-2xl font-black text-primary md:text-3xl" data-id="element-202" data-mp="zmlthzc53adi">{value}</p>
              <p className="mt-1 text-[11px] font-bold leading-tight text-slate-500 md:text-sm" data-id="element-203" data-mp="4al0z9wrz4l9">
                {label}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}